var map = {
	"./a_mood.jpg": 8574,
	"./boba.jpg": 6789,
	"./dell_roof.jpg": 257,
	"./dl_worth.jpg": 1918,
	"./grad_uw.jpg": 9924,
	"./kaohsiung.jpg": 988
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 6799;